import { render, staticRenderFns } from "./CelatAdd.vue?vue&type=template&id=106eaa1e&scoped=true&"
import script from "./CelatAdd.vue?vue&type=script&lang=js&"
export * from "./CelatAdd.vue?vue&type=script&lang=js&"
import style0 from "./CelatAdd.vue?vue&type=style&index=0&id=106eaa1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106eaa1e",
  null
  
)

export default component.exports